<template>
    <dx-popup
        ref="lockRef"
        width="600px"
        height="500px"
        v-model:visible="state.lockPopupVisible"
        :show-close-button="true"
        :hideOnOutsideClick="true"
        :title="title"
        :animation="{ value: false }"
    >
        <ai-form-dates-select-text-box
            ref="lockPopupRef"
            :dataSource="usersState.lockReasons"
            :formData="state.lockFormData"
            :firstPropsObject="blockSinceProps"
            :secondPropsObject="blockUntilProps"
            :thirdPropsObject="tagBoxProps"
        />
        <dx-toolbar-item location="after" toolbar="bottom">
            <dx-button text="Сохранить" @click="onSaveHandler" />
        </dx-toolbar-item>
        <dx-toolbar-item location="after" toolbar="bottom">
            <dx-button text="Отмена" @click="closePopup" />
        </dx-toolbar-item>
    </dx-popup>
</template>

<script setup>
import { ref, watch, onMounted, computed } from 'vue';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxButton, DxPopup } from 'devextreme-vue';
import { dxUiConfirm, dxUiNotify } from '@/utils/dx-helper';
import aiFormDatesSelectTextBox from '@/components/ai-form-dates-select-text-box.vue';
import moment from 'moment';

import usersLocalStore from './store';
const { state } = usersLocalStore;

import usersStore from '@/store/administration/users';
const { usersState, blockUser } = usersStore;

const lockRef = ref();
const lockPopupRef = ref();
const validateCallback = ref();
const isDisabled = ref(state.lockFormData.from === null);

const title = computed(() => {
    return `Блокировка ${state.lockLogins.join(', ')}`;
});

watch(state, () => {
    isDisabled.value = state.lockFormData.from === null;
});

onMounted(() => {
    validateCallback.value = lockPopupRef.value?.fieldValidate;
});

const dateBoxOptions = computed(() => ({
    openOnFieldClick: true,
    displayFormat: 'dd.MM.yy - HH:mm',
    useMaskBehavior: true,
    showClearButton: true,
    type: 'datetime',
}));

const blockSinceProps = computed(() => ({
    isRequired: true,
    editorType: 'dxDateBox',
    dataField: 'from',
    editorOptions: dateBoxOptions,
    label: 'Блокировка с:',
    onValueChanged: blockSinceChanged(),
}));

const blockSinceChanged = () => {
    if (!state.lockFormData.from) {
        state.lockFormData.lock_reason = '';
    }
};

const blockUntilProps = computed(() => ({
    isRequired: false,
    editorType: 'dxDateBox',
    dataField: 'to',
    editorOptions: dateBoxOptions,
    label: 'Блокировка по:',
}));

let tagBoxProps = computed(() => ({
    dataField: 'lock_reason',
    label: 'Причина блокировки:',
    disabled: isDisabled.value,
    isRequired: !isDisabled.value,
}));

const dispatchAction = async params => {
    const response = await blockUser(params);

    dxUiNotify({
        message: `Успешно заблокировано ${response.resume.successCount} пользователей, ${response.resume.userFailedCount} пользователей не подошло под условие блокировки.`,
        type: response.resume.userFailedCount > 0 ? 'warning' : 'success',
    });
};

const onSaveHandler = () => {
    state.lockPopupVisible = false;
    if (!validateCallback.value().isValid) {
        state.lockPopupVisible = true;
    } else {
        const userIds = state.lockUserIds;
        const from = moment(state.lockFormData.from).format('YYYY-MM-DD HH:mm:ss.SSSZ');
        const to = state.lockFormData.to ? moment(state.lockFormData.to).format('YYYY-MM-DD HH:mm:ss.SSSZ') : null;
        state.userRequestBody.lock_reason = state.lockFormData.lock_reason;
        const lock_reason = state.lockFormData.lock_reason[0];

        dxUiConfirm('Вы уверены, что хотите заблокировать пользователя?', 'Подтвердите действие').then(function (
            confirmed
        ) {
            if (confirmed) {
                dispatchAction({ userIds, from, to, lock_reason });
            }
        });
    }
};

const closePopup = () => {
    state.lockPopupVisible = false;
};
</script>
